"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiInputBase = getMuiInputBase;
function getMuiInputBase(palette) {
  return {
    styleOverrides: {
      root: {
        '&.MuiOutlinedInput-root.Mui-disabled': {
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: palette.grey[300]
          }
        },
        '.MuiOutlinedInput-input.Mui-disabled': {
          WebkitTextFillColor: palette.grey[300]
        },
        '.MuiSelect-icon': {
          '&.Mui-disabled': {
            color: palette.grey[300]
          },
          color: palette.common.black
        }
      }
    }
  };
}